import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-xl p-6 md:p-12 border-2 border-green-200" data-id="element-118">
          <div className="flex flex-col items-center text-center" data-id="element-119">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-green-100 rounded-full flex items-center justify-center mb-4 md:mb-6" data-id="element-120">
              <Shield className="w-8 h-8 md:w-10 md:h-10 text-green-600" data-id="element-121" />
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-4 md:mb-6" data-id="element-122">
              🛡️ รับประกันคืนเงิน 100% ภายใน 7 วัน
            </h2>

            <div className="space-y-3 md:space-y-4 text-base md:text-lg text-gray-700 max-w-2xl" data-id="element-123">
              <p data-id="element-124">ดาวน์โหลดทั้งหมด อ่านทั้งหมด</p>
              <p data-id="element-125">นำไปใช้ในคลาสของคุณ</p>
              <p className="font-bold text-navy-primary text-lg md:text-xl mt-2" data-id="element-126">
                ถ้าคุณไม่พอใจ 100% ภายใน 7 วัน
                <br data-id="element-127" />
                เราคืนเงินทุกบาท
              </p>
              <p className="text-sm md:text-base text-gray-600 mt-4 md:mt-6" data-id="element-128">
                ไม่มีคำถาม ไม่มีขั้นตอนยุ่งยาก
                <br data-id="element-129" />
                ความเสี่ยงทั้งหมดเป็นของเราทั้งหมด
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}